<template>
  <div>
    <el-card class="box-card">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth" :inline="true">
        <el-form-item label="维修类型" prop="tableSchema">
          <el-select
            v-model="searchForm.tableSchema"
            placeholder="请选择维修类型"
            @change="pageList"
            clearable
          >
            <el-option v-for="item in tableSchemas" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="表名" prop="tableName">
          <el-input
            v-model="searchForm.tableName"
            placeholder="请输入表名"
            auto-complete="off"
            clearable
          ></el-input>
        </el-form-item>
        <el-button :size="buttonSize" type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
        <el-button
          :size="buttonSize"
          type="primary"
          @click="getGeneratorProperty"
          icon="el-icon-setting"
        >文件配置</el-button>
        <el-button
          :size="buttonSize"
          type="primary"
          @click="generateFile"
          icon="el-icon-printer"
        >生成文件</el-button>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-table
        ref="multipleTable"
        :data="page.records"
        tooltip-effect="dark"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        style="width: 100%;"
        border
        @selection-change="selectionChange"
        v-if="permissions.indexOf('列表') > -1"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="tableSchema" label="维修类型"></el-table-column>
        <el-table-column prop="tableName" label="表名"></el-table-column>
        <el-table-column prop="engine" label="表引擎"></el-table-column>
        <el-table-column prop="tableComment" label="表介绍"></el-table-column>
        <el-table-column prop="createTime" label="日期"></el-table-column>
        <el-table-column prop label="操作" width="100" align="center">
          <template slot-scope="scope">
            <div class="operation-group">
              <span
                @click="generatorRuleFormVisible = true, generatorRuleForm.tableSchema = scope.row.tableSchema, generatorRuleForm.tableName = scope.row.tableName"
                v-if="permissions.indexOf('规则配置') > -1"
              >规则配置</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
        v-if="permissions.indexOf('列表') > -1"
      ></el-pagination>
    </el-card>

    <el-dialog
      :title="searchForm.tableSchema + '生成文件配置'"
      width="80%"
      :visible.sync="generatorPropertyFormVisible"
      left
    >
      <el-form
        :model="generatorPropertyForm"
        :label-width="generatorFormLabelWidth"
        ref="generatorPropertyForm"
      >
        <el-form-item v-show="false" label="id" prop="id">
          <el-input v-model="generatorPropertyForm.id" placeholder auto-complete="off"></el-input>
        </el-form-item>
        <el-row :span="24">
          <span>后台代码设置</span>
          <el-divider></el-divider>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="8">
            <el-form-item label="作者" prop="author">
              <el-input
                v-model="generatorPropertyForm.author"
                placeholder="请输入作者"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="接口地址" prop="apiUrl">
              <el-input
                v-model="generatorPropertyForm.apiUrl"
                placeholder="请输入接口地址(例如：http://localhost/api)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="8">
            <el-form-item label="bean包名" prop="beanPackage">
              <el-input
                v-model="generatorPropertyForm.beanPackage"
                placeholder="请输入bean包名(例如：com.example.demo.bean)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="bean路径" prop="beanPath">
              <el-input
                v-model="generatorPropertyForm.beanPath"
                placeholder="请输入bean路径(例如：c:\User\admin\project\demo\com\example\bean)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="8">
            <el-form-item label="entity包名" prop="entityPackage">
              <el-input
                v-model="generatorPropertyForm.entityPackage"
                placeholder="请输入entity包名(例如：com.example.demo.entity)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="entity路径" prop="entityPath">
              <el-input
                v-model="generatorPropertyForm.entityPath"
                placeholder="请输入entity路径(例如：c:\User\admin\project\demo\com\example\entity)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="8">
            <el-form-item label="enum包名" prop="enumPackage">
              <el-input
                v-model="generatorPropertyForm.enumPackage"
                placeholder="请输入enum包名(例如：com.example.demo.enum)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="enum路径" prop="enumPath">
              <el-input
                v-model="generatorPropertyForm.enumPath"
                placeholder="请输入enum路径(例如：c:\User\admin\project\demo\com\example\enum)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="8">
            <el-form-item label="controller包名" prop="controllerPackage">
              <el-input
                v-model="generatorPropertyForm.controllerPackage"
                placeholder="请输入controller包名(例如：com.example.demo.controller)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="controller路径" prop="controllerPath">
              <el-input
                v-model="generatorPropertyForm.controllerPath"
                placeholder="请输入controller路径(例如：c:\User\admin\project\demo\com\example\controller)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="8">
            <el-form-item label="service包名" prop="servicePackage">
              <el-input
                v-model="generatorPropertyForm.servicePackage"
                placeholder="请输入service包名(例如：com.example.demo.service)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="service路径" prop="servicePath">
              <el-input
                v-model="generatorPropertyForm.servicePath"
                placeholder="请输入service路径(例如：c:\User\admin\project\demo\com\example\service)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="8">
            <el-form-item label="serviceImpl包名" prop="serviceImplPackage">
              <el-input
                v-model="generatorPropertyForm.serviceImplPackage"
                placeholder="请输入serviceImpl包名(例如：com.example.demo.service.serviceImpl)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="serviceImpl路径" prop="serviceImplPath">
              <el-input
                v-model="generatorPropertyForm.serviceImplPath"
                placeholder="请输入serviceImpl路径(例如：c:\User\admin\project\demo\com\example\service\impl)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="8">
            <el-form-item label="mapper包名" prop="mapperPackage">
              <el-input
                v-model="generatorPropertyForm.mapperPackage"
                placeholder="请输入mapper包名(例如：com.example.demo.mapper)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="mapper路径" prop="mapperPath">
              <el-input
                v-model="generatorPropertyForm.mapperPath"
                placeholder="请输入mapper路径(例如：c:\User\admin\project\demo\com\example\mapper)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="16" :offset="8">
            <el-form-item label="mapper映射xml文件路径" prop="mapperXmlPath">
              <el-input
                v-model="generatorPropertyForm.mapperXmlPath"
                placeholder="请输入mapper映射xml路径(例如：resource\mapper)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <span>前端代码设置</span>
          <el-divider></el-divider>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="12">
            <el-form-item label="vue接口文件" prop="vueApiPath">
              <el-input
                v-model="generatorPropertyForm.vueApiPath"
                placeholder="请输入vue接口文件(例如：c:\User\admin\vue\src\api)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="vue页面文件" prop="vuePagePath">
              <el-input
                v-model="generatorPropertyForm.vuePagePath"
                placeholder="请输入vue页面文件(例如：c:\User\admin\vue\src\components)"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="generatorPropertyFormVisible = false">取 消</el-button>
        <el-button :size="buttonSize" type="primary" @click="updateGeneratorProperty">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="生成规则" :visible.sync="generatorRuleFormVisible" left>
      <el-form
        :model="generatorRuleForm"
        :label-width="generatorRuleFormLabelWidth"
        ref="generatorRuleForm"
      >
        <el-row :span="24">
          <span>后台代码设置</span>
          <el-divider></el-divider>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开启后台校验" prop="backEndValidate">
              <el-switch
                v-model="generatorRuleForm.backEndValidate"
                active-color="#409EFF"
                inactive-color="#EBE9E9"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否生成entity" prop="entityNeed">
              <el-switch
                v-model="generatorRuleForm.entityNeed"
                active-color="#409EFF"
                inactive-color="#EBE9E9"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否生成enum" prop="enumNeed">
              <el-switch
                v-model="generatorRuleForm.enumNeed"
                active-color="#409EFF"
                inactive-color="#EBE9E9"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否生成controller" prop="controllerNeed">
              <el-switch
                v-model="generatorRuleForm.controllerNeed"
                active-color="#409EFF"
                inactive-color="#EBE9E9"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否生成service" prop="serviceNeed">
              <el-switch
                v-model="generatorRuleForm.serviceNeed"
                active-color="#409EFF"
                inactive-color="#EBE9E9"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否生成serviceImpl" prop="serviceImplNeed">
              <el-switch
                v-model="generatorRuleForm.serviceImplNeed"
                active-color="#409EFF"
                inactive-color="#EBE9E9"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否生成mapper" prop="mapperNeed">
              <el-switch
                v-model="generatorRuleForm.mapperNeed"
                active-color="#409EFF"
                inactive-color="#EBE9E9"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否生成mapper.xml" prop="mapperXmlNeed">
              <el-switch
                v-model="generatorRuleForm.mapperXmlNeed"
                active-color="#409EFF"
                inactive-color="#EBE9E9"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否开启伪删除" prop="pseudoDeleteNeed">
              <el-switch
                v-model="generatorRuleForm.pseudoDeleteNeed"
                active-color="#409EFF"
                inactive-color="#EBE9E9"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="伪删除列名" :label-width="formLabelWidth">
              <el-select v-model="generatorRuleForm.pseudoDeleteColumn" placeholder="请选择伪删除列名">
                <el-option
                  v-for="item in tableColumns"
                  :key="item.columnName"
                  :label="item.columnName"
                  :value="item.columnName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="创建时间列名" :label-width="formLabelWidth">
              <el-select v-model="generatorRuleForm.createTimeColumn" placeholder="请选择创建时间列名">
                <el-option
                  v-for="item in tableColumns"
                  :key="item.columnName"
                  :label="item.columnName"
                  :value="item.columnName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改时间列名" :label-width="formLabelWidth">
              <el-select v-model="generatorRuleForm.updateTimeColumn" placeholder="请选择修改时间列名">
                <el-option
                  v-for="item in tableColumns"
                  :key="item.columnName"
                  :label="item.columnName"
                  :value="item.columnName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="操作人id列名" :label-width="formLabelWidth">
              <el-select v-model="generatorRuleForm.operatorIdColumn" placeholder="请选择操作人id列名">
                <el-option
                  v-for="item in tableColumns"
                  :key="item.columnName"
                  :label="item.columnName"
                  :value="item.columnName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <span>前台代码设置</span>
          <el-divider></el-divider>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开启前台校验" prop="frontEndValidate">
              <el-switch
                v-model="generatorRuleForm.frontEndValidate"
                active-color="#409EFF"
                inactive-color="#EBE9E9"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否生成接口文件" prop="vueApiNeed">
              <el-switch
                v-model="generatorRuleForm.vueApiNeed"
                active-color="#409EFF"
                inactive-color="#EBE9E9"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否生成页面" prop="vuePageNeed">
              <el-switch
                v-model="generatorRuleForm.vuePageNeed"
                active-color="#409EFF"
                inactive-color="#EBE9E9"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="页面是否需要树" prop="vueTreeNeed">
              <el-switch
                v-model="generatorRuleForm.vueTreeNeed"
                active-color="#409EFF"
                inactive-color="#EBE9E9"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否显示搜索域label" prop="showSearchFormLabel">
              <el-switch
                v-model="generatorRuleForm.showSearchFormLabel"
                active-color="#409EFF"
                inactive-color="#EBE9E9"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <!--<el-form-item label="搜索表单域" prop="searchFormFields">-->
        <!--<el-cascader v-model="generatorRuleForm.searchFormFields" placeholder="请选择需要显示的搜索表单域"-->
        <!--:options="tableColumns" :props="props" @change="handleChangeNode" clearable>-->
        <!--</el-cascader>-->
        <!--</el-form-item>-->
        <!--<el-form-item label="新增表单域" prop="addFormFields">-->
        <!--<el-cascader v-model="generatorRuleForm.addFormFields" placeholder="请选择需要显示的新增表单域"-->
        <!--:options="tableColumns" :props="props" clearable>-->
        <!--</el-cascader>-->
        <!--</el-form-item>-->
        <!--<el-form-item label="编辑表单域" prop="editFormFields">-->
        <!--<el-cascader v-model="generatorRuleForm.editFormFields" placeholder="请选择需要显示的编辑表单域"-->
        <!--:options="tableColumns" :props="props" clearable>-->
        <!--</el-cascader>-->
        <!--</el-form-item>-->
        <!--<el-form-item label="列表展示列" prop="pageListFields">-->
        <!--<el-cascader v-model="generatorRuleForm.pageListFields" placeholder="请选择需要显示的列表展示列"-->
        <!--:options="tableColumns" :props="props" clearable>-->
        <!--</el-cascader>-->
        <!--</el-form-item>-->
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item title="搜索表单域" name="1">
            <el-checkbox-group v-model="generatorRuleForm.searchFormFields">
              <div v-for="column in tableColumns" style="display: block;margin: 5px;">
                <el-checkbox
                  :label="column.columnName"
                  :key="column.columnName"
                  style="width: 300px;"
                >{{column.columnName}}</el-checkbox>
                <el-select v-model="column.elementType" placeholder="请选择元素类型" clearable>
                  <el-option v-for="type in elementTypes" :key="type" :label="type" :value="type"></el-option>
                </el-select>
              </div>
            </el-checkbox-group>
          </el-collapse-item>
          <el-collapse-item title="新增表单域" name="2">
            <el-checkbox-group v-model="generatorRuleForm.addFormFields">
              <div v-for="column in tableColumns" style="display: block;margin: 5px;">
                <el-checkbox
                  :label="column.columnName"
                  :key="column.columnName"
                  style="width: 300px;"
                >{{column.columnName}}</el-checkbox>
                <el-select v-model="column.elementType" placeholder="请选择元素类型" clearable>
                  <el-option v-for="type in elementTypes" :key="type" :label="type" :value="type"></el-option>
                </el-select>
              </div>
            </el-checkbox-group>
          </el-collapse-item>
          <el-collapse-item title="编辑表单域" name="3">
            <el-checkbox-group v-model="generatorRuleForm.editFormFields">
              <div v-for="column in tableColumns" style="display: block;margin: 5px;">
                <el-checkbox
                  :label="column.columnName"
                  :key="column.columnName"
                  style="width: 300px;"
                >{{column.columnName}}</el-checkbox>
                <el-select v-model="column.elementType" placeholder="请选择元素类型" clearable>
                  <el-option v-for="type in elementTypes" :key="type" :label="type" :value="type"></el-option>
                </el-select>
              </div>
            </el-checkbox-group>
          </el-collapse-item>
          <el-collapse-item title="列表展示列" name="4">
            <el-checkbox-group v-model="generatorRuleForm.pageListFields">
              <div v-for="column in tableColumns" style="display: block;margin: 5px;">
                <el-checkbox
                  :label="column.columnName"
                  :key="column.columnName"
                  style="width: 300px;"
                >{{column.columnName}}</el-checkbox>
              </div>
            </el-checkbox-group>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="generatorRuleFormVisible = false">取 消</el-button>
        <el-button :size="buttonSize" type="primary" @click="addGeneratorRule">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: "1",
      loading: false,
      elementTypes: [
        "number",
        "input",
        "textarea",
        "select",
        "datePicker",
        "dateRangePicker",
        "datetimePicker",
        "datetimeRangePicker",
        "switch",
        "checkbox",
        "radio"
      ],
      page: {
        records: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      searchForm: {
        tableSchema: "",
        tableName: ""
      },
      tableSchemas: [],
      formLabelWidth: "90px",
      generatorFormLabelWidth: "160px",
      generatorRuleFormLabelWidth: "140px",
      multipleSelection: [],
      generatorPropertyForm: {},
      generatorPropertyFormRules: [],
      generatorPropertyFormVisible: false,
      generatorForm: {},
      generatorRuleFormVisible: false,
      generatorRuleForm: {
        tableSchema: "",
        tableName: "",
        showSearchFormLabel: false,
        searchFormFields: [],
        addFormFields: [],
        editFormFields: [],
        pageListFields: [],
        frontEndValidate: true,
        backEndValidate: true,
        entityNeed: true,
        enumNeed: true,
        controllerNeed: true,
        serviceNeed: true,
        serviceImplNeed: true,
        mapperNeed: true,
        mapperXmlNeed: true,
        pseudoDeleteNeed: true,
        pseudoDeleteColumn: "",
        vueApiNeed: true,
        vuePageNeed: true,
        vueTreeNeed: true,
        createTimeColumn: "",
        updateTimeColumn: "",
        operatorIdColumn: ""
      },
      tableColumns: [],
      permissions: [],
      buttonSize: document.body.clientWidth < 992 ? "mini" : ""
    };
  },
  methods: {
    pageList() {
      this.loading = true;
      this.api.generator
        .pageList({
          tableSchema: this.searchForm.tableSchema,
          tableName: this.searchForm.tableName,
          pageSize: this.page.pageSize,
          pageNumber: this.page.pageNumber,
          sortName: this.page.sortName,
          sortOrder: this.page.sortOrder
        })
        .then(result => {
          this.loading = false;
          this.page.records = result.data.records;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    getTableSchemas() {
      this.api.generator
        .getTableSchemas({})
        .then(result => {
          this.tableSchemas = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getPermissionList() {
      let user = JSON.parse(localStorage.user);
      user.resources.forEach(e => {
        e.resources.forEach(a => {
          if (a.url == this.$route.path) {
            a.resources.forEach(e => this.permissions.push(e.function));
          }
        });
      });
    },
    updateGeneratorProperty() {
      this.generatorPropertyForm.tableSchema = this.searchForm.tableSchema;
      this.api.generatorProperty
        .updateGeneratorProperty(this.generatorPropertyForm)
        .then(result => {
          this.generatorPropertyFormVisible = false;
          this.$message(result.message);
        })
        .catch(error => {
          console.log(error);
        });
    },
    generateFile() {
      this.api.generator
        .generateFile({
          tableSchema: this.searchForm.tableSchema,
          tables: this.multipleSelection
        })
        .then(result => {
          this.$message(result.message);
        })
        .catch(error => {
          console.log(error);
        });
    },
    selectionChange(val) {
      this.multipleSelection = [];
      val.forEach((item, index) => {
        this.multipleSelection.push(item.tableName);
      });
    },
    getColumns() {
      this.api.generator
        .getColumns({
          tableSchema: this.generatorRuleForm.tableSchema,
          tableName: this.generatorRuleForm.tableName
        })
        .then(result => {
          this.tableColumns = result.data;
          this.tableColumns.forEach(column => {
            if (
              column.dataType === "float" ||
              column.dataType === "double" ||
              column.dataType === "int" ||
              column.dataType === "bigint" ||
              column.dataType === "decimal"
            ) {
              column.elementType = "number";
            }
            if (
              column.dataType === "char" ||
              column.dataType === "varchar" ||
              column.dataType === "text"
            ) {
              if (column.characterMaximumLength < 256) {
                column.elementType = "input";
              } else {
                column.elementType = "textarea";
              }
            }
            if (column.dataType === "date") {
              column.elementType = "datePicker";
            }
            if (column.dataType === "datetime") {
              column.elementType = "datetimePicker";
            }
          });
          this.getGeneratorRule();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getGeneratorProperty() {
      this.generatorPropertyFormVisible = true;
      this.getByTableSchema();
    },
    getByTableSchema() {
      this.api.generatorProperty
        .getByTableSchema({
          tableSchema: this.searchForm.tableSchema
        })
        .then(result => {
          this.generatorPropertyForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addGeneratorRule() {
      this.generatorRuleForm.searchFormFields.forEach((e, index) => {
        this.tableColumns.forEach(a => {
          if (a.columnName == e) {
            this.generatorRuleForm.searchFormFields[index] = a;
          }
        });
      });
      this.generatorRuleForm.addFormFields.forEach((e, index) => {
        this.tableColumns.forEach(a => {
          if (a.columnName == e) {
            this.generatorRuleForm.addFormFields[index] = a;
          }
        });
      });
      this.generatorRuleForm.editFormFields.forEach((e, index) => {
        this.tableColumns.forEach(a => {
          if (a.columnName == e) {
            this.generatorRuleForm.editFormFields[index] = a;
          }
        });
      });
      this.generatorRuleForm.pageListFields.forEach((e, index) => {
        this.tableColumns.forEach(a => {
          if (a.columnName == e) {
            this.generatorRuleForm.pageListFields[index] = a;
          }
        });
      });
      this.api.generatorRule
        .addGeneratorRule(this.generatorRuleForm)
        .then(result => {
          if (result.success) {
            this.generatorRuleFormVisible = false;
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getGeneratorRule() {
      this.api.generatorRule
        .getGeneratorRule({
          tableSchema: this.generatorRuleForm.tableSchema,
          tableName: this.generatorRuleForm.tableName
        })
        .then(result => {
          if (result.data !== null) {
            this.generatorRuleForm = result.data;
            this.generatorRuleForm.searchFormFields.forEach(
              (e, index) =>
                (this.generatorRuleForm.searchFormFields[index] = e.columnName)
            );
            this.generatorRuleForm.addFormFields.forEach(
              (e, index) =>
                (this.generatorRuleForm.addFormFields[index] = e.columnName)
            );
            this.generatorRuleForm.editFormFields.forEach(
              (e, index) =>
                (this.generatorRuleForm.editFormFields[index] = e.columnName)
            );
            this.generatorRuleForm.pageListFields.forEach(
              (e, index) =>
                (this.generatorRuleForm.pageListFields[index] = e.columnName)
            );
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {
    generatorRuleFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.generatorRuleForm.resetFields();
      } else {
        this.getColumns();
      }
    },
    generatorPropertyFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.generatorPropertyForm.resetFields();
      }
    }
  },
  mounted() {
    this.getPermissionList();
    this.pageList();
    this.getTableSchemas();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/generator/index.vue